const orderLineSelected = (value, vm) => {
    const found = value.find(element => element.checked === true);
    if (found !== undefined) {
        return true;
    }
    return false;
};

var couriersMixin = {
    data: function () {
        return {
            couriers: [],
            trackingUrls: [],
            trackingInputs: [],
            trackingDisabled:[]
        }
    },
    methods: {
        getCouriers: function () {
            const vm = this;
            axios({
                method: 'get',
                url: '/Umbraco/BackOffice/Api/OrderDeliveryDetails/GetCouriers/'
            }).then(function (response) {
                const data = response.data;
                vm.couriers = data;
            }).catch(function (error) {
                if (error.response) {
                    console.log(error.response.data);
                }
            });
        },
        getCourier: function (courierCode) {
            const vm = this;
            return vm.couriers.find(courier => courier.courierCode === courierCode);
        },

        updateTrackAndTraceUrl: function (index, $event) {
            const vm = this;
            const input = $event.target.value;
           
            const trackingParameters = input.split(",");

            if (vm.trackingUrls[index] === undefined)
                return;

            let template = vm.couriers[vm.trackingUrls[index].courierIndex].trackingUrl;

            for (let i = 0; i < trackingParameters.length; i++) {
                template = template.replace("{" + i + "}", trackingParameters[i].trim());
            }

            vm.trackingUrls[index].trackingUrl = template;
            vm.trackingUrls[index].trackAndTrace = input;
        }, 
        parseTrackAndTraceUrl: function (template, trackAndTrace) {
            const trackingParameters = trackAndTrace.split(",");

            if (template === 'undefined') {
                return
            }

            for (let i = 0; i < trackingParameters.length; i++) {
                template = template.replace("{" + i + "}", trackingParameters[i].trim());
            }

            return template;
        },
        defaultTrackingUrlObject: function() {
            return [
                {
                    orderId: 0,
                    orderNumber: '',
                    courierIndex: -1,
                    courierCode: '',
                    trackAndTrace: '',
                    trackingUrl: '', 
                    trackingAvailable: true
                }
            ];
        },
        changeCourier: function (orderId, index, $event) {
            const vm = this;
            const courierIndex = $event.target.value;
            const trackingParameters = vm.$refs['trackingParameters'];

            if (courierIndex == -1) {
                console.log(courierIndex, 'is -1')    
                vm.trackingUrls = vm.defaultTrackingUrlObject();
                vm.trackingDisabled[index] = true;
                return;
            }

            const courier = vm.couriers[courierIndex];
            console.log('courier:', courier)
            if (!courier.trackingAvailable) {
                vm.trackingDisabled[index] = true;
                if (trackingParameters.length > 0)
                    trackingParameters[index].value = '';
                else
                    trackingParameters.value = '';
            }
            else
            {
                vm.trackingDisabled[index] = false;
            }

            const obj = {
                orderId: orderId,
                courierIndex: Number(courierIndex),
                courierCode: courier.courierCode,
                trackAndTrace: courier.trackAndTrace,
                trackingUrl: courier.trackingUrl,
                trackingAvailable: courier.trackingAvailable
            }

            var trackingUrls = vm.trackingUrls[index];
            if (trackingUrls === undefined) {
                vm.trackingUrls.push(obj);
            } else {
                trackingUrls.courierCode = courier.courierCode;
                trackingUrls.trackAndTrace = courier.trackAndTrace;
                trackingUrls.trackingUrl = courier.trackingUrl;
                trackingUrls.courierIndex = Number(courierIndex);
                trackingUrls.trackingAvailable = courier.trackingAvailable;
            }
        },
        changePacker: function (orderId, index, $event) {
            
        }
    }
}